import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            用户反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {commentsData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.items.map((comment) => (
            <div key={comment.name} className="bg-background-50 rounded-lg p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line text-sm"></i>
                </div>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}